import { render, staticRenderFns } from "./EqifyRulePersonIsMemberOfOrganisation.vue?vue&type=template&id=c5c6eda6&scoped=true"
import script from "./EqifyRulePersonIsMemberOfOrganisation.vue?vue&type=script&lang=ts"
export * from "./EqifyRulePersonIsMemberOfOrganisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c6eda6",
  null
  
)

export default component.exports